import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import FormDialog from '../../../components/FormDialog';
import CustomTextField from '../../../components/Form/TextField';
import { isLabPartner, isTechnicianOrAdmin } from '../../../helpers';

const SaveForLater = ({ value, proceed, cancel }) => {
  const currentUser = useSelector(state => state.auth.user);
  const actionOwnerName =
    (isTechnicianOrAdmin(currentUser) || isLabPartner(currentUser)) &&
    currentUser.first_name &&
    currentUser.last_name
      ? `${currentUser.first_name} ${currentUser.last_name}`
      : '';
  const [data, setData] = useState({
    action_owner_name: actionOwnerName,
    reason: '',
    should_notify_office: false
  });

  useEffect(() => {
    if (!value) {
      proceed();
    }
  });

  const handleChange = ({ target }) => {
    setData({ ...data, [target.name]: target.type === 'checkbox' ? target.checked : target.value });
  };

  const handleClose = response => {
    if (response) {
      proceed(data);
    } else {
      cancel();
    }
  };

  return (
    <FormDialog
      open
      titleText="Save For Later"
      acceptButtonText="Continue"
      handleClose={handleClose}
      isAcceptButtonDisabled={data.action_owner_name === '' || data.reason === ''}
    >
      <TextField
        autoFocus
        margin="dense"
        id="action_owner_name"
        name="action_owner_name"
        label="Your Name"
        type="text"
        required
        value={data.action_owner_name}
        disabled={!!actionOwnerName}
        onChange={handleChange}
        fullWidth
      />
      <CustomTextField
        margin="dense"
        id="reason"
        name="reason"
        label="Reason"
        type="text"
        required
        removeUnnecessaryWhitespaces
        value={data.reason}
        onChange={handleChange}
        fullWidth
        multiline
      />
    </FormDialog>
  );
};

SaveForLater.propTypes = {
  value: PropTypes.bool.isRequired,
  proceed: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired
};

export default SaveForLater;
